// lib/list/factoryImageMentions.ts
import { z } from 'zod';

export const factoryImageIdentitySchema = z.object({ folderId: z.string().min(1).max(120), imageId: z.string().min(1).max(120) }).strict();
export const factoryImageSelectionSchema = z.array(factoryImageIdentitySchema).max(12).refine(items => new Set(items.map(factoryImageId)).size === items.length, 'Choose each Factory image once.');
export const factoryImageId = (image: { folderId: string; imageId: string }) => JSON.stringify([image.folderId, image.imageId]);
export function parseFactoryImageId(id: string) {
  try {
    const pair = z.tuple([z.string(), z.string()]).parse(JSON.parse(id));
    return factoryImageIdentitySchema.parse({ folderId: pair[0], imageId: pair[1] });
  } catch { return undefined; }
}
export const factoryImageMention = (image: { folderId: string; imageId: string }, name: string) =>
  `@factory-image:${encodeURIComponent(image.folderId)}/${encodeURIComponent(image.imageId)}[${encodeURIComponent(name)}]`;

const token = /(?<tildes>~{3,})[\s\S]*?(?:\k<tildes>|$)|(?<ticks>`+)[\s\S]*?(?:\k<ticks>|$)|!?\[[^\]\n]*\]\([^)\n]*\)|https?:\/\/[^\s]+|(?<prefix>^|[\s(*_])(?<mention>@factory-image:(?<folder>[a-z0-9%_~.-]+)\/(?<image>[a-z0-9%_~.-]+)\[(?<label>[^\]\s]*)\])(?=$|[\s),.;:!?*_])/gi;
export function factoryImageMentions(text: string) {
  return [...text.matchAll(token)].flatMap(match => {
    if (!match.groups?.mention) return [];
    try {
      const image = factoryImageIdentitySchema.parse({ folderId: decodeURIComponent(match.groups.folder!), imageId: decodeURIComponent(match.groups.image!) });
      const name = decodeURIComponent(match.groups.label!);
      if (!name || name.length > 240) return [];
      return [{ ...image, id: factoryImageId(image), name, token: match.groups.mention, start: match.index + (match.groups.prefix?.length ?? 0) }];
    } catch { return []; }
  });
}
